import { useQueryClient } from '@tanstack/react-query';

import { queryKeys } from 'api/config';

import { SessionTranscriptResponse } from 'features/sessions/config/types';
import { useSessionsQueryActions } from 'features/sessions/hooks/useSessionsQueryActions';

export const useSessionTranscriptQueryActions = (sessionId: string) => {
  const queryClient = useQueryClient();
  const { updateSession } = useSessionsQueryActions();

  const getTranscript = () => {
    return queryClient.getQueryData<SessionTranscriptResponse>([
      queryKeys.coachSessionTranscript,
      sessionId,
    ]);
  };

  const setTranscript = (transcript: string) => {
    queryClient.setQueryData<SessionTranscriptResponse>(
      [queryKeys.coachSessionTranscript, sessionId],
      () => ({ transcript })
    );
    updateSession(sessionId, { isTranscriptAvailable: true });
  };

  const resetTranscript = () => {
    queryClient.removeQueries([queryKeys.coachSessionTranscript, sessionId]);
    updateSession(sessionId, { isTranscriptAvailable: false });
  };

  return {
    setTranscript,
    getTranscript,
    resetTranscript,
  };
};
